module.exports = __webpack_public_path__ + "static/media/image81.6128bc52.png";